import React from 'react';
import { Button } from '../common/Button';

interface HubCommunicationCardProps {
  sectionTitle: string;
  header?: React.ReactNode;
  children: React.ReactNode;
  addMessageButton?: {
    onClick: () => void;
    disabled: boolean;
    label: string;
  };
  addMessageModal?: React.ReactNode;
}

export const HubCommunicationCard: React.FC<HubCommunicationCardProps> = ({
  sectionTitle,
  header,
  children,
  addMessageButton,
  addMessageModal,
}) => {
  return (
    <section>
      <div className="mb-2 text-dark text-xs uppercase font-semibold">{sectionTitle}</div>
      <div className="rounded-[1.5625rem] p-6 shadow-drop bg-white">
        {header && <div className="mb-4 flex flex-wrap items-center gap-6">{header}</div>}

        {children}

        {addMessageButton && (
          <div className="mt-4 flex justify-end">
            <Button
              className="md:w-[253px]"
              onClick={addMessageButton.onClick}
              disabled={addMessageButton.disabled}
            >
              {addMessageButton.label}
            </Button>
          </div>
        )}
      </div>

      {addMessageModal}
    </section>
  );
};
